// Comprehensive list of countries and their major cities

export interface CountryCityData {
  [country: string]: string[];
}

export const countriesAndCities: CountryCityData = {
  "Afghanistan": ["Kabul", "Kandahar", "Herat", "Mazar-i-Sharif", "Jalalabad"],
  "Albania": ["Tirana", "Durrës", "Vlorë", "Shkodër", "Elbasan"],
  "Algeria": ["Algiers", "Oran", "Constantine", "Annaba", "Blida"],
  "Andorra": ["Andorra la Vella", "Escaldes-Engordany", "Encamp", "La Massana"],
  "Angola": ["Luanda", "Huambo", "Lobito", "Benguela", "Lubango"],
  "Argentina": ["Buenos Aires", "Córdoba", "Rosario", "Mendoza", "La Plata", "San Miguel de Tucumán", "Mar del Plata"],
  "Armenia": ["Yerevan", "Gyumri", "Vanadzor", "Vagharshapat", "Hrazdan"],
  "Australia": ["Sydney", "Melbourne", "Brisbane", "Perth", "Adelaide", "Gold Coast", "Canberra", "Newcastle"],
  "Austria": ["Vienna", "Graz", "Linz", "Salzburg", "Innsbruck"],
  "Azerbaijan": ["Baku", "Ganja", "Sumqayit", "Mingachevir", "Lankaran"],
  "Bahamas": ["Nassau", "Freeport", "West End", "Cooper's Town", "Marsh Harbour"],
  "Bahrain": ["Manama", "Riffa", "Muharraq", "Hamad Town", "A'ali"],
  "Bangladesh": ["Dhaka", "Chittagong", "Khulna", "Rajshahi", "Sylhet", "Comilla"],
  "Barbados": ["Bridgetown", "Speightstown", "Oistins", "Bathsheba", "Holetown"],
  "Belarus": ["Minsk", "Gomel", "Mogilev", "Vitebsk", "Grodno", "Brest"],
  "Belgium": ["Brussels", "Antwerp", "Ghent", "Charleroi", "Liège", "Bruges"],
  "Belize": ["Belmopan", "Belize City", "San Ignacio", "Orange Walk", "Corozal"],
  "Benin": ["Porto-Novo", "Cotonou", "Parakou", "Djougou", "Bohicon"],
  "Bhutan": ["Thimphu", "Phuntsholing", "Paro", "Punakha", "Wangdue Phodrang"],
  "Bolivia": ["La Paz", "Santa Cruz", "Cochabamba", "Sucre", "Oruro", "Potosí"],
  "Bosnia and Herzegovina": ["Sarajevo", "Banja Luka", "Tuzla", "Zenica", "Mostar"],
  "Botswana": ["Gaborone", "Francistown", "Molepolole", "Maun", "Selebi-Phikwe"],
  "Brazil": ["São Paulo", "Rio de Janeiro", "Brasília", "Salvador", "Fortaleza", "Belo Horizonte", "Manaus", "Curitiba", "Recife", "Porto Alegre"],
  "Brunei": ["Bandar Seri Begawan", "Kuala Belait", "Seria", "Tutong", "Bangar"],
  "Bulgaria": ["Sofia", "Plovdiv", "Varna", "Burgas", "Ruse"],
  "Burkina Faso": ["Ouagadougou", "Bobo-Dioulasso", "Koudougou", "Ouahigouya", "Banfora"],
  "Burundi": ["Gitega", "Bujumbura", "Muyinga", "Ngozi", "Ruyigi"],
  "Cambodia": ["Phnom Penh", "Siem Reap", "Battambang", "Sihanoukville", "Kampong Cham"],
  "Cameroon": ["Yaoundé", "Douala", "Garoua", "Bamenda", "Bafoussam"],
  "Canada": ["Toronto", "Montreal", "Vancouver", "Calgary", "Edmonton", "Ottawa", "Winnipeg", "Quebec City", "Hamilton", "Kitchener"],
  "Cape Verde": ["Praia", "Mindelo", "Santa Maria", "Assomada", "São Filipe"],
  "Central African Republic": ["Bangui", "Bimbo", "Berbérati", "Carnot", "Bambari"],
  "Chad": ["N'Djamena", "Moundou", "Sarh", "Abéché", "Kelo"],
  "Chile": ["Santiago", "Valparaíso", "Concepción", "La Serena", "Antofagasta", "Temuco", "Viña del Mar"],
  "China": ["Beijing", "Shanghai", "Guangzhou", "Shenzhen", "Chengdu", "Chongqing", "Tianjin", "Wuhan", "Xi'an", "Hangzhou", "Nanjing", "Shenyang"],
  "Colombia": ["Bogotá", "Medellín", "Cali", "Barranquilla", "Cartagena", "Cúcuta", "Bucaramanga"],
  "Comoros": ["Moroni", "Mutsamudu", "Fomboni", "Domoni", "Tsimbeo"],
  "Congo (Brazzaville)": ["Brazzaville", "Pointe-Noire", "Dolisie", "Nkayi", "Mossendjo"],
  "Congo (Kinshasa)": ["Kinshasa", "Lubumbashi", "Mbuji-Mayi", "Kisangani", "Kananga"],
  "Costa Rica": ["San José", "Limón", "Alajuela", "Heredia", "Puntarenas", "Cartago"],
  "Croatia": ["Zagreb", "Split", "Rijeka", "Osijek", "Zadar"],
  "Cuba": ["Havana", "Santiago de Cuba", "Camagüey", "Holguín", "Santa Clara"],
  "Cyprus": ["Nicosia", "Limassol", "Larnaca", "Famagusta", "Paphos"],
  "Czech Republic": ["Prague", "Brno", "Ostrava", "Plzeň", "Liberec"],
  "Denmark": ["Copenhagen", "Aarhus", "Odense", "Aalborg", "Esbjerg"],
  "Djibouti": ["Djibouti City", "Ali Sabieh", "Tadjoura", "Obock", "Dikhil"],
  "Dominica": ["Roseau", "Portsmouth", "Marigot", "Berekua", "Mahaut"],
  "Dominican Republic": ["Santo Domingo", "Santiago", "La Romana", "San Pedro de Macorís", "San Cristóbal"],
  "Ecuador": ["Quito", "Guayaquil", "Cuenca", "Santo Domingo", "Machala", "Manta"],
  "Egypt": ["Cairo", "Alexandria", "Giza", "Shubra El Kheima", "Port Said", "Suez", "Luxor", "Aswan"],
  "El Salvador": ["San Salvador", "Santa Ana", "San Miguel", "Soyapango", "Santa Tecla"],
  "Equatorial Guinea": ["Malabo", "Bata", "Ebebiyin", "Aconibe", "Añisoc"],
  "Eritrea": ["Asmara", "Keren", "Massawa", "Assab", "Mendefera"],
  "Estonia": ["Tallinn", "Tartu", "Narva", "Pärnu", "Kohtla-Järve"],
  "Eswatini": ["Mbabane", "Manzini", "Big Bend", "Malkerns", "Nhlangano"],
  "Ethiopia": ["Addis Ababa", "Dire Dawa", "Mekelle", "Gondar", "Bahir Dar", "Hawassa"],
  "Fiji": ["Suva", "Lautoka", "Nadi", "Labasa", "Ba"],
  "Finland": ["Helsinki", "Espoo", "Tampere", "Vantaa", "Oulu", "Turku"],
  "France": ["Paris", "Marseille", "Lyon", "Toulouse", "Nice", "Nantes", "Strasbourg", "Montpellier", "Bordeaux", "Lille"],
  "Gabon": ["Libreville", "Port-Gentil", "Franceville", "Oyem", "Moanda"],
  "Gambia": ["Banjul", "Serekunda", "Brikama", "Bakau", "Basse Santa Su"],
  "Georgia": ["Tbilisi", "Batumi", "Kutaisi", "Rustavi", "Zugdidi"],
  "Germany": ["Berlin", "Hamburg", "Munich", "Cologne", "Frankfurt", "Stuttgart", "Düsseldorf", "Dortmund", "Essen", "Leipzig"],
  "Ghana": ["Accra", "Kumasi", "Tamale", "Sekondi-Takoradi", "Ashaiman"],
  "Greece": ["Athens", "Thessaloniki", "Patras", "Heraklion", "Larissa"],
  "Grenada": ["St. George's", "Gouyave", "Grenville", "Victoria", "Sauteurs"],
  "Guatemala": ["Guatemala City", "Mixco", "Villa Nueva", "Quetzaltenango", "Escuintla"],
  "Guinea": ["Conakry", "Nzérékoré", "Kankan", "Kindia", "Labé"],
  "Guinea-Bissau": ["Bissau", "Bafatá", "Gabú", "Bissorã", "Bolama"],
  "Guyana": ["Georgetown", "Linden", "New Amsterdam", "Anna Regina", "Bartica"],
  "Haiti": ["Port-au-Prince", "Cap-Haïtien", "Gonaïves", "Les Cayes", "Port-de-Paix"],
  "Honduras": ["Tegucigalpa", "San Pedro Sula", "Choloma", "La Ceiba", "El Progreso"],
  "Hungary": ["Budapest", "Debrecen", "Szeged", "Miskolc", "Pécs"],
  "Iceland": ["Reykjavik", "Kópavogur", "Hafnarfjörður", "Akureyri", "Reykjanesbær"],
  "India": ["Mumbai", "Delhi", "Bangalore", "Hyderabad", "Ahmedabad", "Chennai", "Kolkata", "Pune", "Jaipur", "Lucknow", "Kanpur", "Nagpur"],
  "Indonesia": ["Jakarta", "Surabaya", "Bandung", "Medan", "Semarang", "Makassar", "Palembang", "Tangerang", "Denpasar"],
  "Iran": ["Tehran", "Mashhad", "Isfahan", "Karaj", "Tabriz", "Shiraz", "Qom"],
  "Iraq": ["Baghdad", "Basra", "Mosul", "Erbil", "Kirkuk", "Najaf", "Sulaymaniyah"],
  "Ireland": ["Dublin", "Cork", "Limerick", "Galway", "Waterford"],
  "Israel": ["Jerusalem", "Tel Aviv", "Haifa", "Rishon LeZion", "Petah Tikva", "Ashdod"],
  "Italy": ["Rome", "Milan", "Naples", "Turin", "Palermo", "Genoa", "Bologna", "Florence", "Venice"],
  "Jamaica": ["Kingston", "Spanish Town", "Portmore", "Montego Bay", "May Pen"],
  "Japan": ["Tokyo", "Yokohama", "Osaka", "Nagoya", "Sapporo", "Fukuoka", "Kobe", "Kyoto", "Kawasaki", "Hiroshima"],
  "Jordan": ["Amman", "Zarqa", "Irbid", "Russeifa", "Aqaba"],
  "Kazakhstan": ["Almaty", "Nur-Sultan", "Shymkent", "Karaganda", "Aktobe"],
  "Kenya": ["Nairobi", "Mombasa", "Kisumu", "Nakuru", "Eldoret"],
  "Kiribati": ["Tarawa", "Betio", "Bikenibeu", "Teaoraereke"],
  "Kosovo": ["Pristina", "Prizren", "Ferizaj", "Peja", "Gjakova"],
  "Kuwait": ["Kuwait City", "Al Ahmadi", "Hawally", "Salmiya", "Sabah Al-Salem"],
  "Kyrgyzstan": ["Bishkek", "Osh", "Jalal-Abad", "Karakol", "Tokmok"],
  "Laos": ["Vientiane", "Pakse", "Savannakhet", "Luang Prabang", "Thakhek"],
  "Latvia": ["Riga", "Daugavpils", "Liepāja", "Jelgava", "Jūrmala"],
  "Lebanon": ["Beirut", "Tripoli", "Sidon", "Tyre", "Nabatieh"],
  "Lesotho": ["Maseru", "Teyateyaneng", "Mafeteng", "Hlotse", "Mohale's Hoek"],
  "Liberia": ["Monrovia", "Gbarnga", "Kakata", "Bensonville", "Harper"],
  "Libya": ["Tripoli", "Benghazi", "Misrata", "Tarhuna", "Bayda"],
  "Liechtenstein": ["Vaduz", "Schaan", "Balzers", "Triesen", "Eschen"],
  "Lithuania": ["Vilnius", "Kaunas", "Klaipėda", "Šiauliai", "Panevėžys"],
  "Luxembourg": ["Luxembourg City", "Esch-sur-Alzette", "Differdange", "Dudelange", "Ettelbruck"],
  "Madagascar": ["Antananarivo", "Toamasina", "Antsirabe", "Fianarantsoa", "Mahajanga"],
  "Malawi": ["Lilongwe", "Blantyre", "Mzuzu", "Zomba", "Kasungu"],
  "Malaysia": ["Kuala Lumpur", "George Town", "Ipoh", "Shah Alam", "Petaling Jaya", "Johor Bahru", "Malacca City"],
  "Maldives": ["Malé", "Addu City", "Fuvahmulah", "Kulhudhuffushi", "Thinadhoo"],
  "Mali": ["Bamako", "Sikasso", "Mopti", "Koutiala", "Ségou"],
  "Malta": ["Valletta", "Birkirkara", "Mosta", "Qormi", "Żabbar"],
  "Marshall Islands": ["Majuro", "Ebeye", "Arno", "Jabor", "Wotje"],
  "Mauritania": ["Nouakchott", "Nouadhibou", "Néma", "Kaédi", "Rosso"],
  "Mauritius": ["Port Louis", "Beau Bassin-Rose Hill", "Vacoas-Phoenix", "Curepipe", "Quatre Bornes"],
  "Mexico": ["Mexico City", "Guadalajara", "Monterrey", "Puebla", "Tijuana", "León", "Juárez", "Zapopan", "Cancún"],
  "Micronesia": ["Palikir", "Weno", "Kolonia", "Tofol", "Colonia"],
  "Moldova": ["Chișinău", "Tiraspol", "Bălți", "Bender", "Rîbnița"],
  "Monaco": ["Monaco", "Monte Carlo", "La Condamine", "Fontvieille"],
  "Mongolia": ["Ulaanbaatar", "Erdenet", "Darkhan", "Choibalsan", "Mörön"],
  "Montenegro": ["Podgorica", "Nikšić", "Pljevlja", "Bijelo Polje", "Cetinje"],
  "Morocco": ["Casablanca", "Rabat", "Fez", "Marrakech", "Tangier", "Agadir", "Meknes"],
  "Mozambique": ["Maputo", "Matola", "Beira", "Nampula", "Chimoio"],
  "Myanmar": ["Yangon", "Mandalay", "Naypyidaw", "Mawlamyine", "Bago"],
  "Namibia": ["Windhoek", "Rundu", "Walvis Bay", "Oshakati", "Swakopmund"],
  "Nauru": ["Yaren", "Denigomodu", "Aiwo", "Anabar", "Anibare"],
  "Nepal": ["Kathmandu", "Pokhara", "Lalitpur", "Bharatpur", "Biratnagar"],
  "Netherlands": ["Amsterdam", "Rotterdam", "The Hague", "Utrecht", "Eindhoven", "Groningen"],
  "New Zealand": ["Auckland", "Wellington", "Christchurch", "Hamilton", "Tauranga", "Dunedin"],
  "Nicaragua": ["Managua", "León", "Masaya", "Matagalpa", "Chinandega"],
  "Niger": ["Niamey", "Zinder", "Maradi", "Agadez", "Tahoua"],
  "Nigeria": ["Lagos", "Kano", "Ibadan", "Abuja", "Port Harcourt", "Benin City", "Kaduna"],
  "North Korea": ["Pyongyang", "Hamhung", "Chongjin", "Nampo", "Wonsan"],
  "North Macedonia": ["Skopje", "Bitola", "Kumanovo", "Prilep", "Tetovo"],
  "Norway": ["Oslo", "Bergen", "Stavanger", "Trondheim", "Drammen"],
  "Oman": ["Muscat", "Salalah", "Sohar", "Nizwa", "Sur"],
  "Pakistan": ["Karachi", "Lahore", "Faisalabad", "Rawalpindi", "Multan", "Gujranwala", "Peshawar", "Islamabad"],
  "Palau": ["Ngerulmud", "Koror", "Airai", "Melekeok"],
  "Palestine": ["Gaza City", "Hebron", "Nablus", "Ramallah", "Khan Yunis"],
  "Panama": ["Panama City", "San Miguelito", "Tocumen", "David", "Arraiján"],
  "Papua New Guinea": ["Port Moresby", "Lae", "Arawa", "Mount Hagen", "Popondetta"],
  "Paraguay": ["Asunción", "Ciudad del Este", "San Lorenzo", "Luque", "Capiatá"],
  "Peru": ["Lima", "Arequipa", "Trujillo", "Chiclayo", "Cusco", "Piura"],
  "Philippines": ["Manila", "Quezon City", "Davao City", "Caloocan", "Cebu City", "Zamboanga City", "Antipolo"],
  "Poland": ["Warsaw", "Kraków", "Łódź", "Wrocław", "Poznań", "Gdańsk"],
  "Portugal": ["Lisbon", "Porto", "Amadora", "Braga", "Setúbal", "Coimbra"],
  "Qatar": ["Doha", "Al Rayyan", "Umm Salal Mohammed", "Al Wakrah", "Al Khor"],
  "Romania": ["Bucharest", "Cluj-Napoca", "Timișoara", "Iași", "Constanța", "Craiova"],
  "Russia": ["Moscow", "Saint Petersburg", "Novosibirsk", "Yekaterinburg", "Kazan", "Nizhny Novgorod", "Chelyabinsk", "Samara", "Omsk", "Rostov-on-Don"],
  "Rwanda": ["Kigali", "Butare", "Gitarama", "Ruhengeri", "Gisenyi"],
  "Saint Kitts and Nevis": ["Basseterre", "Charlestown", "Dieppe Bay Town", "Middle Island"],
  "Saint Lucia": ["Castries", "Vieux Fort", "Micoud", "Soufrière", "Dennery"],
  "Saint Vincent and the Grenadines": ["Kingstown", "Georgetown", "Barrouallie", "Port Elizabeth"],
  "Samoa": ["Apia", "Vaitele", "Faleula", "Siusega", "Malie"],
  "San Marino": ["San Marino", "Serravalle", "Borgo Maggiore", "Domagnano"],
  "Sao Tome and Principe": ["São Tomé", "Santo António", "Trindade", "Neves", "Santana"],
  "Saudi Arabia": ["Riyadh", "Jeddah", "Mecca", "Medina", "Dammam", "Khobar", "Tabuk"],
  "Senegal": ["Dakar", "Touba", "Thiès", "Kaolack", "Saint-Louis"],
  "Serbia": ["Belgrade", "Novi Sad", "Niš", "Kragujevac", "Subotica"],
  "Seychelles": ["Victoria", "Anse Boileau", "Beau Vallon", "Cascade", "Bel Air"],
  "Sierra Leone": ["Freetown", "Bo", "Kenema", "Makeni", "Koidu"],
  "Singapore": ["Singapore", "Jurong", "Woodlands", "Tampines", "Bedok"],
  "Slovakia": ["Bratislava", "Košice", "Prešov", "Žilina", "Nitra"],
  "Slovenia": ["Ljubljana", "Maribor", "Celje", "Kranj", "Velenje"],
  "Solomon Islands": ["Honiara", "Gizo", "Auki", "Munda", "Kirakira"],
  "Somalia": ["Mogadishu", "Hargeisa", "Berbera", "Kismayo", "Merca"],
  "South Africa": ["Johannesburg", "Cape Town", "Durban", "Pretoria", "Port Elizabeth", "Bloemfontein", "East London"],
  "South Korea": ["Seoul", "Busan", "Incheon", "Daegu", "Daejeon", "Gwangju", "Suwon"],
  "South Sudan": ["Juba", "Malakal", "Wau", "Yei", "Yambio"],
  "Spain": ["Madrid", "Barcelona", "Valencia", "Seville", "Zaragoza", "Málaga", "Bilbao", "Alicante"],
  "Sri Lanka": ["Colombo", "Kandy", "Galle", "Jaffna", "Negombo", "Trincomalee"],
  "Sudan": ["Khartoum", "Omdurman", "Nyala", "Port Sudan", "Kassala"],
  "Suriname": ["Paramaribo", "Lelydorp", "Nieuw Nickerie", "Moengo", "Nieuw Amsterdam"],
  "Sweden": ["Stockholm", "Gothenburg", "Malmö", "Uppsala", "Västerås"],
  "Switzerland": ["Zurich", "Geneva", "Basel", "Lausanne", "Bern", "Winterthur"],
  "Syria": ["Damascus", "Aleppo", "Homs", "Latakia", "Hama"],
  "Taiwan": ["Taipei", "Kaohsiung", "Taichung", "Tainan", "Hsinchu"],
  "Tajikistan": ["Dushanbe", "Khujand", "Kulob", "Qurghonteppa", "Istaravshan"],
  "Tanzania": ["Dar es Salaam", "Mwanza", "Arusha", "Dodoma", "Mbeya"],
  "Thailand": ["Bangkok", "Nonthaburi", "Nakhon Ratchasima", "Chiang Mai", "Hat Yai", "Udon Thani", "Phuket"],
  "Timor-Leste": ["Dili", "Baucau", "Maliana", "Suai", "Lospalos"],
  "Togo": ["Lomé", "Sokodé", "Kara", "Atakpamé", "Kpalimé"],
  "Tonga": ["Nuku'alofa", "Neiafu", "Haveluloto", "Vaini", "Pangai"],
  "Trinidad and Tobago": ["Port of Spain", "San Fernando", "Chaguanas", "Arima", "Point Fortin"],
  "Tunisia": ["Tunis", "Sfax", "Sousse", "Kairouan", "Bizerte"],
  "Turkey": ["Istanbul", "Ankara", "Izmir", "Bursa", "Adana", "Gaziantep", "Konya", "Antalya"],
  "Turkmenistan": ["Ashgabat", "Türkmenabat", "Daşoguz", "Mary", "Balkanabat"],
  "Tuvalu": ["Funafuti", "Vaitupu", "Nanumea", "Nui", "Nukufetau"],
  "Uganda": ["Kampala", "Gulu", "Lira", "Mbarara", "Jinja"],
  "Ukraine": ["Kyiv", "Kharkiv", "Odesa", "Dnipro", "Donetsk", "Zaporizhzhia", "Lviv"],
  "United Arab Emirates": ["Dubai", "Abu Dhabi", "Sharjah", "Al Ain", "Ajman", "Ras Al Khaimah"],
  "United Kingdom": ["London", "Birmingham", "Manchester", "Glasgow", "Liverpool", "Leeds", "Edinburgh", "Bristol", "Newcastle"],
  "United States": ["New York", "Los Angeles", "Chicago", "Houston", "Phoenix", "Philadelphia", "San Antonio", "San Diego", "Dallas", "San Jose", "Austin", "Jacksonville", "Fort Worth", "Columbus", "Charlotte", "San Francisco", "Indianapolis", "Seattle", "Denver", "Washington DC", "Boston", "Nashville", "Detroit", "Portland", "Las Vegas", "Miami", "Atlanta"],
  "Uruguay": ["Montevideo", "Salto", "Paysandú", "Las Piedras", "Rivera"],
  "Uzbekistan": ["Tashkent", "Samarkand", "Namangan", "Andijan", "Bukhara"],
  "Vanuatu": ["Port Vila", "Luganville", "Norsup", "Isangel", "Sola"],
  "Vatican City": ["Vatican City"],
  "Venezuela": ["Caracas", "Maracaibo", "Valencia", "Barquisimeto", "Maracay", "Ciudad Guayana"],
  "Vietnam": ["Ho Chi Minh City", "Hanoi", "Da Nang", "Bien Hoa", "Nha Trang", "Hue", "Can Tho"],
  "Yemen": ["Sana'a", "Aden", "Taiz", "Hodeidah", "Ibb"],
  "Zambia": ["Lusaka", "Ndola", "Kitwe", "Kabwe", "Chingola"],
  "Zimbabwe": ["Harare", "Bulawayo", "Chitungwiza", "Mutare", "Gweru"]
};

export const countries = Object.keys(countriesAndCities).sort();
